import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {
  AbstractWorkflowService,
  ConfigurationService,
  UUID,
  WorkflowStateSerialForm,
  WorkflowTransition
} from '@nh/angular-tses';
import {STATE_METADATA} from 'app/workflow/state-metadata';
import {Graph} from './graph';
import {WorkflowStates} from './workflow-states';

export interface StateMetadata {
  displayName: string;
  colour?: string;
  timelineDisplayText?: string;
}

export interface TransitionMetadata {
  isCriticalPath: boolean;
  buttonName: string;
}

@Injectable({
  providedIn: 'root'
})
export class WorkflowService extends AbstractWorkflowService {
  private stateGraph: WorkflowTransition[];

  private stateMetadata: Record<WorkflowStates, StateMetadata> = null;

  constructor(
    protected _snackbar: MatSnackBar,
    protected _configurationService: ConfigurationService,
    protected _http: HttpClient
  ) {
    super(_snackbar, _configurationService, _http);
  }

  public getStateMetadata(): Promise<Record<WorkflowStates, StateMetadata>> {
    if (this.stateMetadata) {
      return Promise.resolve(this.stateMetadata);
    } else {
      return Promise.resolve(STATE_METADATA);
    }
  }

  public getState(associatedObjectId: UUID, time?: number): Promise<WorkflowStateSerialForm> {
    return super._getState(associatedObjectId, time);
  }

  public getStateGraph(): Promise<WorkflowTransition[]> {
    if (this.stateGraph) {
      return Promise.resolve(this.stateGraph);
    } else {
      return super._getStateGraph().then((stateGraph: WorkflowTransition[]) => {
        this.stateGraph = stateGraph;
        return stateGraph;
      });
    }
  }

  public getPotentialTransitions(associatedObjectId: UUID): Promise<string[]> {
    return super._getPotentialTransitions(associatedObjectId);
  }

  public getRemainingStates(graph: Graph, from: string, to: string): string[] {
    const path: string[] = graph.getPath(from, to);
    return path ? path.splice(1, path.length - 1) : null;
  }
}
